import {IEvent} from "../../../models/eventModel";


export interface CalendarState {
    events: IEvent[],
    isLoading: boolean,
    nearestTournament?: IEvent,
}

export enum CalendarActionsEnum {
    SET_EVENTS = 'SET_EVENTS',
    SET_IS_LOADING = 'SET_IS_LOADING',
    SET_NEAREST_TOURNAMENT = 'SET_NEAREST_TOURNAMENT',
}

export interface setEventsAction {
    type: CalendarActionsEnum.SET_EVENTS,
    payload: IEvent[],
}

export interface setIsLoadingAction {
    type: CalendarActionsEnum.SET_IS_LOADING,
    payload: boolean
}

export interface setNearestTournamentAction {
    type: CalendarActionsEnum.SET_NEAREST_TOURNAMENT,
    payload: IEvent,
}

export type CalendarAction = setEventsAction | setIsLoadingAction | setNearestTournamentAction
